import { curryN, identity } from 'ramda';

export const pass = (): void => void 0;

/**
 * string -> ([{}], merge) -> {}
 */
export const classify = curryN(
    2,
    (
        key: string,
        list: Array<Record<string, unknown>>,
        merge = identity
    ): { [key: string]: unknown } =>
        list.reduce<{ [key: string]: unknown }>((st, item) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            st[item[key] as string] = merge(item, item[key], st);
            return st;
        }, {})
);

export const isEmpty = (value): boolean => {
    if (value == null) return true;

    if (Array.isArray(value) || typeof value === 'string') return !value.length;

    for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) return false;
    }

    return true;
};

export const get = (obj, path, defValue) => {
    if (!path) return undefined;

    const pathArray = Array.isArray(path) ? path : path.split('.');
    const result = pathArray.reduce((prevObj, key) => prevObj && prevObj[key], obj);
    return result === undefined ? defValue : result;
};

export const set = (object, path, value) => {
    const pathArray = Array.isArray(path) ? path : path.split('.');

    pathArray.reduce((acc, key, i) => {
        if (acc[key] === undefined) acc[key] = {};
        if (i === pathArray.length - 1) acc[key] = value;

        return acc[key];
    }, object);
};

export const keyBy = (array, key) =>
    (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});

export const seq =
    (...funcs) =>
    () =>
        funcs.forEach(f => f?.());

export const bitsToNumber = (bits: boolean[]): number =>
    bits.length ? parseInt(bits.map(bit => Number(Boolean(bit))).join(''), 2) : 0;
